import { Download } from 'lucide-react';

/**
 * Drag-over affordance: dashed primary frame below the titlebar while a file drag hovers
 * the window. pointer-events-none — the actual drop handlers live on the window root, so
 * the overlay must never swallow the drop.
 */
function NotesDropOverlay() {
  return (
    <div className="pointer-events-none absolute inset-x-2 bottom-2 top-11 z-40 flex flex-col items-center justify-center gap-2 rounded-[10px] border-2 border-dashed border-primary bg-primary/10 text-primary">
      <Download className="size-6" aria-hidden />
      <span className="text-[13px] font-bold">Drop to add file</span>
      <span className="text-[11px] font-normal opacity-80">stored in your notes, max 25 MB</span>
    </div>
  );
}

export default NotesDropOverlay;
